import cx from 'classnames';
import { forwardRef } from 'react';
import type { MouseEventHandler, ReactElement } from 'react';

import { Button } from '@trello/nachos/button';
import type { TestId } from '@trello/test-ids';

import styles from './IslandNavButton.less';

interface IslandNavButtonProps {
  className?: string;
  icon: ReactElement;
  isDisabled?: boolean;
  isPrimary?: boolean;
  isSelected?: boolean;
  onClick?: MouseEventHandler<HTMLButtonElement>;
  testId?: TestId;
  title?: string;
  label?: string;
  showLabels?: boolean;
}

export const IslandNavButton = forwardRef<
  HTMLButtonElement,
  IslandNavButtonProps
>(
  (
    {
      className,
      icon,
      isDisabled = false,
      isPrimary = false,
      isSelected = false,
      onClick,
      testId,
      title,
      label,
      showLabels = false,
    },
    ref,
  ) => {
    return (
      <Button
        className={cx(styles.button, className, {
          [styles.primary]: isPrimary,
          [styles.selected]: isSelected,
          [styles.withLabel]: showLabels,
        })}
        appearance="subtle"
        shouldFitContainer={true}
        isDisabled={isDisabled}
        onClick={onClick}
        ref={ref}
        title={title}
        testId={testId}
        iconBefore={
          showLabels ? <span className={styles.icon}>{icon}</span> : undefined
        }
        role="checkbox"
        aria-checked={isSelected}
      >
        {!showLabels ? icon : null}
        {isSelected && <span className={styles.indicator}></span>}
        {showLabels && label}
      </Button>
    );
  },
);
